import { render, staticRenderFns } from "./JanusViewer.vue?vue&type=template&id=17701038&scoped=true&"
import script from "./JanusViewer.vue?vue&type=script&lang=js&"
export * from "./JanusViewer.vue?vue&type=script&lang=js&"
import style0 from "./JanusViewer.vue?vue&type=style&index=0&id=17701038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17701038",
  null
  
)

export default component.exports